import { IParamsPlaceOrderFlam } from 'constants/interface';
import { sendGet, sendPut } from './axios';

// eslint-disable-next-line import/prefer-default-export
export const getMasterData = () => sendGet('/master');

export const getFormMasterData = (params: IParamsPlaceOrderFlam) => sendGet('/form-validation', params);
